import ('./style.scss')

import Amchart from './base-chart'

export default Amchart